import { useMutation, useQueryClient } from 'react-query'

// eslint-disable-next-line import/no-internal-modules
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
// eslint-disable-next-line import/no-internal-modules
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

export const useMutateExternalPONumbering = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (value: boolean) =>
      SystemPreferencesRepository.updateSystemPreference(
        SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE,
        value
      ),
    onSuccess: () => queryClient.invalidateQueries(systemPreferencesKeys.all),
  })

  const mutateAsync = async (value: boolean): Promise<void> => {
    await mutation.mutateAsync(value)
  }

  return {
    mutateAsync,
    isLoading: mutation.isLoading,
  }
}
